import { urlEnvironments } from 'constants/env'
import store from 'store'

import { isString } from './miscellaneous'

export const getEnvUrls = () => {
    const state = store.getState()
    const { environment } = state.app

    if (isString(environment)) {
        return urlEnvironments[environment.toUpperCase()]
    }

    // sending development as fallback , useful for local development
    return urlEnvironments['DEVELOPMENT']
}
